import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { View } from 'foundations-components/components/View';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styled from 'foundations-theming/utils';
import InsightsEmptyState from './InsightsEmptyState';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import UILink from 'UIComponents/link/UILink';
import { TInsightIcon } from '../EmailInsights/InsightIcon';
import { getEmailDetilsPageLink } from 'messaging-publishing-lib/Insights/utils';
import { trackInsightsInteraction } from 'messaging-publishing-lib/utils/tracking';
import { SpotlightHeading } from '../EmailInsights/Spotlights';
import InsightsErrorState from './InsightsErrorState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledSpan = styled.span.withConfig({
  displayName: "InsightsList__StyledSpan",
  componentId: "sc-1u2edeo-0"
})(({
  theme
}) => {
  return Object.assign({}, theme.typography['heading-50']);
});
function InsightsList({
  context,
  insights = [],
  footer,
  error
}) {
  if (error) {
    return /*#__PURE__*/_jsx(InsightsErrorState, {});
  }
  if (insights.length === 0) {
    return /*#__PURE__*/_jsx(InsightsEmptyState, {
      panelName: "listing"
    });
  }
  const renderedInsights = insights.map((insight, index) => {
    if (insight.insightCategory !== 'DELIVERABILITY_METRIC') return null;
    const {
      insightType,
      createdAt,
      entityInfo: {
        name: contentName,
        contentId: emailId
      },
      metadata: {
        metricRate,
        comparisonContext: {
          baselineRate
        }
      }
    } = insight;
    const polarity = insight.sentiment === 'POSITIVE';
    return /*#__PURE__*/_jsx(View, {
      borderBlockEndColor: "border-core-subtle",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      children: /*#__PURE__*/_jsxs(MediaObject, {
        padding: "400",
        itemLeft: /*#__PURE__*/_jsx(TInsightIcon, {
          polarity: polarity,
          marginBlockStart: "100"
        }),
        children: [/*#__PURE__*/_jsxs(TFlex, {
          justifyContent: "space-between",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(Small, {
            weight: "medium",
            color: "text-core-subtle",
            textTransform: "uppercase",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `messaging-insights.insights.spotlights.${insightType}.name`
            })
          }), /*#__PURE__*/_jsx(Small, {
            color: "text-core-subtle",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "messaging-insights.insights.generatedOn",
              options: {
                date: /*#__PURE__*/_jsx(FormattedDateTime, {
                  value: createdAt,
                  format: "ll"
                }),
                time: /*#__PURE__*/_jsx(FormattedDateTime, {
                  value: createdAt,
                  format: "LT"
                })
              }
            })
          })]
        }), /*#__PURE__*/_jsxs(View, {
          children: [/*#__PURE__*/_jsx(StyledSpan, {
            children: /*#__PURE__*/_jsx(SpotlightHeading, {
              current: metricRate,
              expected: baselineRate,
              context: context,
              insightType: insightType
            })
          }), ' ', "\"", contentName, "\"."]
        }), /*#__PURE__*/_jsx(UILink, {
          href: getEmailDetilsPageLink(emailId),
          onClick: () => {
            trackInsightsInteraction({
              action: 'click-view-email-insights'
            });
          },
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "messaging-insights.insights.viewEmail"
          })
        })]
      })
    }, index);
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderedInsights, footer]
  });
}
export default InsightsList;